const LIMIT = 10
const CART_ATTRIBUTE_KEY = 'recently_viewed_products'
const SESSION_STORAGE_KEY = 'recentlyViewedProducts'

class RecentlyViewedStore {
  #items = window.localStorage.getItem(SESSION_STORAGE_KEY)
    ? JSON.parse(window.localStorage.getItem(SESSION_STORAGE_KEY))
    : []

  track () {
    if (window.ShopifyAnalytics.meta.page.pageType !== 'product') {
      return this.sync()
    }

    const handle = window.location.pathname.split('/').pop()
    if (!handle) return

    this.set(handle)
  }

  async set (handle) {
    const newItems = (this.#items.includes(handle)
      ? [handle].concat(this.#items.filter(h => h !== handle))
      : [handle].concat(this.#items)
    ).slice(0, LIMIT)
    window.localStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(newItems))

    await window.BAO.Cart.updateCartAttributes({
      [CART_ATTRIBUTE_KEY]: newItems.join(','),
    })

    return newItems
  }

  async sync () {
    await window.BAO.Cart.updateCartAttributes({
      [CART_ATTRIBUTE_KEY]: this.#items.join(','),
    })
  }

  get items () {
    return this.#items.slice(0, LIMIT)
  }
}

const store = Object.freeze(new RecentlyViewedStore())
store.track()

window.BAO.RecentlyViewed = {
  store,
}
